<!-- 代购账号 -->
<template>
	<div class="purchasing-page">
		<div class="section-header" style="margin-bottom: 0;">
			<div class="section-divider"></div>
			<h3>{{ $t('purchasingPlatformAccount') }}</h3>
		</div>

		<!-- 温馨提示 -->
		<div class="warning-message">
			{{ $t('purchasingWarning') }}
		</div>

		<div class="purchasing-layout">
			<!-- 操作按钮区域 -->
			<div class="action-buttons">
				<el-button type="primary" class="add-button" icon="el-icon-plus"
					@click="handleAdd">{{ $t('add') }}</el-button>
				<el-button type="warning" plain icon="el-icon-delete"
					@click="deleteSelected">{{ $t('batchDelete') }}</el-button>
			</div>

			<!-- 账号列表 -->
			<table class="account-list">
				<tbody>
					<!-- 账号项 -->
					<tr class="account-item" v-for="(account, index) in accounts" :key="index">
						<td class="col-checkbox">
							<el-checkbox v-model="account.selected" class="account-checkbox"></el-checkbox>
							<span class="default-tag" v-if="account.defaulted">{{ $t('default') }}</span>
						</td>
						<td class="col-name">
							<div style="display: flex;align-items: center;">
								<span class="account-type">{{ account.platformName }}</span>
								<img :src="account.platformIcon" alt="Logo" class="account-logo">
							</div>
						</td>
						<td class="col-account">
							<span class="account-label">{{ $t('account') }}:</span>
							<span class="account-email">{{ account.account }}</span>
						</td>
						<td class="col-actions">
							<a href="#" class="action-link" v-if="account.sortOrder!=0"
								@click="moveUp(account.id,index-1)">{{ $t('moveUp') }}</a>
							<span class="action-separator" v-if="account.sortOrder!=0">|</span>
							<a href="#" class="action-link" v-if="account.sortOrder+1!=accounts.length"
								@click="moveDown(account.id,index+1)">{{ $t('moveDown') }}</a>
							<span class="action-separator" v-if="account.sortOrder+1!=accounts.length">|</span>
							<a href="#" class="action-link" v-if="!account.defaulted"
								@click="setAsDefault(account.id)">{{ $t('setAsDefault') }}</a>
							<span class="action-separator" v-if="!account.defaulted">|</span>
							<a href="#" class="action-link" @click="editAccount(account)">{{ $t('edit') }}</a>
							<span class="action-separator">|</span>
							<a href="#" class="action-link delete-link"
								@click="deleteAccount(account.id)">{{ $t('delete') }}</a>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<!-- 加载更多状态 -->
		<div v-if="!loading" class="loading-more" style="margin: 30px 0; text-align: center;">
			<i class="el-icon-loading"></i>
			<span>{{$t('dataLoading')}}</span>
		</div>

		<div class="nodata" v-if="accounts.length==0&&loading" style="margin-top: 150px;">
			<img src="/icon/common/nodata.png">
			<span>{{$t('noData')}}</span>
		</div>

		<el-dialog :title="$t('add')" :visible.sync="visible" width="500px" top="5vh" center class="account-dialog"
			:before-close="handleClose" :close-on-click-modal="false">
			<el-form :model="accountForm" :rules="accountRules" ref="accountForm" label-width="140px"
				class="account-form" label-position="top">
				<el-row>
					<el-col :span="24">
						<!-- 代购平台 -->
						<el-form-item :label="$t('purchasingPlatform')" prop="platformId">
							<el-select v-model="accountForm.platformId" :placeholder="$t('selectPurchasingPlatform')"
								class="form-select">
								<el-option :label="platform.platformName" :value="platform.id"
									v-for="(platform,index) in platforms" :key="index">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<!-- 代购平台账号 -->
					<el-col :span="24">
						<el-form-item :label="$t('purchasingPlatformAccount')" prop="account">
							<el-input v-model="accountForm.account"
								:placeholder="$t('inputPurchasingPlatformAccount')"></el-input>
						</el-form-item>
					</el-col>
					<!-- 代购平台密码 -->
					<el-col :span="24">
						<el-form-item :label="$t('purchasingPlatformPassword')" prop="password">
							<el-input v-model="accountForm.password"
								:placeholder="$t('inputPurchasingPlatformPassword')"></el-input>
						</el-form-item>
					</el-col>
					<!-- 设为默认下单平台 -->
					<el-col :span="24">
						<el-form-item :label="$t('setAsDefaultPurchasingPlatform')" prop="defaulted">
							<el-radio-group v-model="accountForm.defaulted">
								<el-radio :label="true">{{ $t('yes') }}</el-radio>
								<el-radio :label="false">{{ $t('no') }}</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose">{{ $t('cancel') }}</el-button>
				<el-button type="primary" @click="submitAccount" :loading="isSubmit">{{ $t('confirm') }}</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import homeApi from '@/api/home';
	import purchasingApi from '@/api/purchasing';
	export default {
		name: 'Purchasing',
		data() {
			return {
				isAdd: true,
				loading: false,
				visible: false,
				isSubmit: false,
				accountForm: {
					platformId: '',
					account: '',
					password: '',
					defaulted: false,
					enabled: true
				},
				platforms: [],
				accounts: []
			}
		},
		created() {
			this.loading = false;
			this.getPlatform();
			this.getPlatformAccount();
		},
		computed: {
			accountRules() {
				return {
					platformId: [{
						required: true,
						message: this.$t('selectPurchasingPlatform'),
						trigger: 'change'
					}],
					account: [{
						required: true,
						message: this.$t('inputPurchasingPlatformAccount'),
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: this.$t('inputPurchasingPlatformPassword'),
						trigger: 'blur'
					}],
					defaulted: [{
						required: true,
						message: this.$t('pleaseSetDefaultPurchasingPlatform'),
						trigger: 'change'
					}]
				}
			}
		},
		methods: {
			//获取代购平台信息
			async getPlatform() {
				const res = await homeApi.getPlatform();
				this.platforms = res.result;
			},
			//获取代购平台账号列表信息
			async getPlatformAccount() {
				const res = await purchasingApi.getList({
					pageNum: 1,
					pageSize: 200
				})
				this.accounts = res.result.records.map(item => {
					return {
						...item,
						selected: false
					}
				})
				this.loading = true;
			},
			//添加代购平台账号弹窗
			handleAdd() {
				this.isAdd = true;
				this.accountForm = {
					platformId: '',
					account: '',
					password: '',
					defaulted: false,
					enabled: true
				}
				this.visible = true;
			},
			//关闭弹窗
			handleClose() {
				this.visible = false;
			},
			//保存
			submitAccount() {
				this.$refs.accountForm.validate(async (valid) => {
					if (valid) {
						if (this.isAdd) {
							this.accountForm.sortOrder = this.accounts.length;
							const res = await purchasingApi.add(this.accountForm)
							if (res.code == 200) {
								this.$message.success(this.$t('addPurchasingSuccess'));
								this.getPlatformAccount();
								this.visible = false;
							} else if (res.code == 91001) {
								this.$message.warning(this.$t('existPurchasing'));
							} else {
								this.$message.warning(this.$t('addPurchasingFail'));
							}
						} else {
							const res = await purchasingApi.update(this.accountForm.id, this.accountForm)
							if (res.code == 200) {
								this.$message.success(this.$t('updatePurchasingSuccess'));
								this.getPlatformAccount();
								this.visible = false;
							} else if (res.code == 91001) {
								this.$message.warning(this.$t('existPurchasing'));
							} else {
								this.$message.warning(this.$t('updatePurchasingFail'));
							}
						}
					}
				})
			},
			//批量删除
			deleteSelected() {
				var selectData = this.accounts.filter(item => item.selected);
				if (selectData.length == 0) {
					return this.$message.warning(this.$t('selectDeleteData'))
				}
				this.$confirm(this.$t('deleteTip'), this.$t('tip'), {
					confirmButtonText: this.$t('confirm'),
					cancelButtonText: this.$t('cancel'),
					type: 'warning'
				}).then(() => {
					this.confirmBatchDelete(selectData);
				}).catch(() => {
					// 处理取消事件，避免报错
				})
			},
			//确认批量删除
			async confirmBatchDelete(selectData) {

				await Promise.all(
					selectData.map(async (item) => {
						await purchasingApi.delete(item.id);
					})
				);
				
				this.getPlatformAccount();

			},
			//上移
			async moveUp(id, prevIndex) {
				const res = await purchasingApi.moveUp(id, this.accounts[prevIndex].id);
				this.getPlatformAccount();
			},
			//下移
			async moveDown(id, nextIndex) {
				const res = await purchasingApi.moveDown(id, this.accounts[nextIndex].id);
				this.getPlatformAccount();
			},
			//设为默认
			async setAsDefault(id) {
				const res = await purchasingApi.setDefault(id);
				this.$message.success(this.$t('settingSuccess'));
				this.getPlatformAccount();
			},
			//编辑
			editAccount(account) {
				this.isAdd = false;
				this.accountForm = {
					...account
				};
				this.visible = true;
			},
			//单个删除
			deleteAccount(id) {
				this.$confirm(this.$t('deleteTip'), this.$t('tip'), {
					confirmButtonText: this.$t('confirm'),
					cancelButtonText: this.$t('cancel'),
					type: 'warning'
				}).then(() => {
					this.confirmDelete(id);
				}).catch(() => {
					// 处理取消事件，避免报错
				})
			},
			//确认删除
			async confirmDelete(id) {
				const res = await purchasingApi.delete(id);
				this.getPlatformAccount();
			},
		}
	}
</script>

<style scoped>
	.purchasing-page {
		padding: 20px;
		max-width: 1200px;
		margin: 0 auto;
	}

	/* 温馨提示样式 */
	.warning-message {
		color: #999;
		margin: 15px 0;
		font-size: 13px;
	}

	.purchasing-tip {
		font-size: 13px;
		color: #999;
		margin: 20px 0;
	}

	.section-header {
		display: flex;
		align-items: center;
		margin-bottom: 30px;
	}

	.section-divider {
		width: 5px;
		height: 20px;
		background-color: #016AF8;
		margin-right: 10px;
	}

	.section-header h3 {
		margin: 0;
		font-size: 18px;
		font-weight: 600;
		color: #333;
	}

	.action-buttons {
		margin-bottom: 20px;
	}

	.add-button {
		background-color: #016AF8;
	}

	.account-list {
		width: 100%;
		background-color: white;
		border-radius: 4px;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
		border-collapse: collapse;
	}

	.account-item {
		border-bottom: 1px solid #f0f0f0;
	}

	.account-item:last-child {
		border-bottom: none;
	}

	.account-item td {
		padding: 15px 10px;
		vertical-align: middle;
	}

	/* 第一列：复选框、默认标签 */
	.col-checkbox {
		width: 10%;
		white-space: nowrap;
	}

	/* 第二列：名称、图标 */
	.col-name {
		width: 20%;
		white-space: nowrap;
	}

	/* 第三列：账号 */
	.col-account {
		width: 50%;
	}

	/* 第四列：操作 */
	.col-actions {
		width: 20%;
		text-align: right;
		white-space: nowrap;
	}

	/* 确保表格单元格内的元素正确对齐 */
	.col-checkbox,
	.col-name,
	.col-account {
		text-align: left;
	}

	.account-checkbox {
		margin-right: 10px;
	}

	.default-tag {
		background-color: #ff9800;
		color: white;
		padding: 4px 10px;
		border-radius: 4px;
		font-size: 12px;
		margin-left: 10px;
	}

	.account-type {
		margin-right: 10px;
		font-weight: bold;
	}

	.account-logo {
		width: 30px;
		height: 30px;
		border-radius: 5px;
		border: 1px solid #f2f2f2;
	}

	.account-label {
		margin-right: 5px;
		color: #666;
	}

	.account-email {
		color: #333;
	}

	.action-link {
		color: #016AF8;
		text-decoration: none;
		margin: 0 5px;
		font-size: 14px;
	}

	.action-separator {
		color: #ddd;
		margin: 0 5px;
	}

	.delete-link {
		color: #ff4d4f;
	}

	.account-dialog {
		border-radius: 8px;
	}

	.account-dialog .el-dialog {
		border-radius: 8px;
	}

	.account-dialog .el-dialog__header {
		border-bottom: 1px solid #eee;
		padding-bottom: 15px;
	}

	.account-dialog .el-dialog__title {
		font-weight: 600;
	}

	.account-form {
		padding: 10px;
		margin-top: -30px;
	}

	.account-form .el-form-item {
		margin-bottom: 20px;
	}

	.account-form .el-form-item__label {
		font-weight: 500;
		color: #333;
	}

	.form-select {
		width: 100%;
	}

	.account-form .el-input__inner {
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		transition: border-color 0.2s;
	}

	.account-form .el-input__inner:hover {
		border-color: #c0c4cc;
	}

	.account-form .el-input__inner:focus {
		border-color: #0171F9;
	}

	.account-form .el-textarea__inner {
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		transition: border-color 0.2s;
	}

	.account-form .el-textarea__inner:hover {
		border-color: #c0c4cc;
	}

	.account-form .el-textarea__inner:focus {
		border-color: #0171F9;
	}

	.account-form .el-select .el-input__inner {
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		transition: border-color 0.2s;
	}

	.account-form .el-select .el-input__inner:hover {
		border-color: #c0c4cc;
	}

	.account-form .el-select .el-input__inner:focus {
		border-color: #0171F9;
	}

	.dialog-footer {
		display: flex;
		justify-content: right;
		margin-top: -40px;
	}

	.dialog-footer .el-button {
		padding: 10px 30px;
		border-radius: 4px;
	}

	.dialog-footer .el-button--primary {
		background-color: #0171F9;
		border-color: #0171F9;
	}

	.dialog-footer .el-button--primary:hover {
		background-color: #0158d4;
		border-color: #0158d4;
	}

	:deep .el-input__inner {
		color: #000 !important;
		border: 1px solid #DCDFE6 !important;
	}

	:deep .el-form-item__label {
		margin-bottom: -18px;
	}
</style>